import React from 'react';

function Footer() {
  return (
    <footer style={{ background: '#eee', color: '#333', padding: '12px 0', textAlign: 'center', position: 'fixed', width: '100%', bottom: 0 }}>
      <small>&copy; {new Date().getFullYear()} LinkBridge. All rights reserved.</small>
    </footer>
  );
}

export default Footer;
